
      import ClockLine from './clock-line.vue'
      import type { App, Plugin } from 'vue'

      export const ClockLinePlugin: Plugin = {
        install(app: App) {
          app.component('ClockLine', ClockLine)
        },
      }
      export { ClockLine }
      